import { LabelsInterface, LabelsListInterface } from './Types';

const LABELS_LIMIT = 15;

const getSlicedLabels = (labelsList: LabelsInterface[]) => {
  const needsSplit = labelsList.length > LABELS_LIMIT;

  if (needsSplit) {
    return {
      firstBatch: labelsList.slice(0, LABELS_LIMIT),
      secondBatch: labelsList.slice(LABELS_LIMIT),
    };
  }

  return {
    firstBatch: labelsList,
  };
};

/**
 *
 * On PDF we max the amount of labels to show.
 * This function returns an array of labels by plan.
 */

export const getLabelsList: (
  currentLabels: LabelsInterface[],
  recommendedLabels: LabelsInterface[],
) => LabelsListInterface[] = (currentLabels, recommendedLabels) => {
  const currentLabelsBatch = getSlicedLabels(currentLabels);
  const recommendedLabelsBatch = getSlicedLabels(recommendedLabels);

  const firstBatch = {
    current: currentLabelsBatch.firstBatch,
    ...(recommendedLabelsBatch.firstBatch && { recommended: recommendedLabelsBatch.firstBatch }),
  };

  const secondBatch = {
    ...(currentLabelsBatch.secondBatch && { current: currentLabelsBatch.secondBatch }),
    ...(recommendedLabelsBatch.secondBatch && { recommended: recommendedLabelsBatch.secondBatch }),
  };

  if (secondBatch && Object.keys(secondBatch).length > 0) {
    return [firstBatch, secondBatch];
  }

  return [firstBatch];
};

export const getPortfolioTitle = (pivot, filterPivot) => {
  if (filterPivot === 'All') {
    return `${filterPivot} ${pivot}`;
  }
  return `${pivot}: ${filterPivot}`;
};
